import { Button } from "@app/components";
import { Modal } from "@app/components/modals";
import { useToast } from "@app/hooks";
import { useModal } from "@app/hooks/useModal";
import { catalogApi, modalsSelectors } from "@app/store";
import { useAppSelector } from "@app/store/hooks";
import { ICatalog } from "@app/common";
import { useForm } from "react-hook-form";

interface CatalogPublishModalProps {
  id: string;
}

const extractApiCustomMessage = (error: any) => {
  return error?.data?.data?.message;
}

export const CatalogPublishModalId = 'CatalogPublishModal';

export const CatalogPublishModal = ({ id }: CatalogPublishModalProps) => {
  const toast = useToast();
  const modal = useModal(id);

  const modalData = useAppSelector(state => modalsSelectors.selectById(state, id));

  const catalog = modalData?.data as ICatalog;

  const [publish, { isLoading, error: apiErrors }] = catalogApi.usePublishCatalogMutation();

  const formMethods = useForm({
    defaultValues: {
      connector: undefined,
    },
  });

  const onPublish = async () => {
    try {
      await publish({ catalogId: catalog._id }).unwrap();

      formMethods.reset();

      toast.success('Votre catalogue à bien été publié.')
    } catch (error) {
      const message = extractApiCustomMessage(error) || 'Une erreur est survenue lors de la publication du catalogue.';

      toast.error(message, { autoClose: 5000 })
    }

    modal.close();
  }

  return (
    <Modal isOpen={!!modalData?.isOpen}>
      <Modal.Title>Informations</Modal.Title>

      <Modal.Subtitle>Vous allez publier ce catalogue sur les connecteurs suivants:</Modal.Subtitle>

      <Modal.Message>
        {catalog?.catalogToConnectors.map(catalogToConnector => (
          <p key={catalogToConnector._id}>
            {catalogToConnector.connector.name}
          </p>
        ))}
      </Modal.Message>

      <Modal.Action>
        <Button title='Annuler' onPress={() => modal.close()} large />
        <Button title='Publier' onPress={formMethods.handleSubmit(onPublish)} large bordered loading={isLoading} />
      </Modal.Action>
    </Modal>
  );
}